import React, { useEffect, useState } from "react";
import BlogPost from "./BlogPost";
import BlogPostCard from "./BlogPostCard";
import { useLocation, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import ComponentSEO from "../../components/SEO_Component/ComponentSEO";
import BreadcrumbNav from "../../components/BreadcrumbNav";

const BlogPage = () => {
  const { id } = useParams();
  const [listOfSimilarBlog, setListOfSimilarBlog] = useState([]);
  const [blog, setBlog] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  window.scrollTo({
    top: 0,
    behavior: "instant",
  });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}blog/${id}?debug=true`)
      .then((response) => response.json())
      .then((data) => {
        setBlog(data);
        setListOfSimilarBlog(data.similar);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      {isLoading && (
        <div className="w-full flex items-center justify-center h-[80vh]">
          <CircularProgress />
        </div>
      )}

      {!isLoading && (
        <>
          <BreadcrumbNav
            pathSegments={[
              {
                caption: "Home",
                href: "/english",
              },
              {
                caption: "Blog",
                href: "/blog",
              },
              {
                caption: blog && blog.title,
                href: location.pathname,
              },
            ]}
          />
          <div className="block w-full px-4 md:px-48">
            <BlogPost {...blog} />
            <ComponentSEO title={blog.seo_title} desc={blog.seo_description} />
            {listOfSimilarBlog.length > 0 && (
              <>
                <h2 className="text-black font-montserrat text-2xl mt-6 md:mt-12 mb-4 font-semibold">
                  Recommended
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-4">
                  {listOfSimilarBlog.map(
                    (item) => item && <BlogPostCard {...item} />
                  )}
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default BlogPage;
